const PlannerSections = {
    home: 0,
    yourDetails: 1,
    groupSelection: 2,
    courseSelection: 3,
}

class NavigationController {

    constructor() {
        //remove header on schedule slider
        $('.nav-close,.nav-open').click(function (e) {
            $('body').toggleClass('nav-active');
        });

        this.slickController = $('.planner').slick({
            arrows: false,
            adaptiveHeight: true,
            infinite: false,
            draggable: false,
            fade: true,
        });
        
        this.slickController.on('afterChange', function (event, slick, currentSlide) {

            this.actions(slick, currentSlide);
            this.removeHeader(slick, currentSlide);
        }.bind(this));

        $('.btn-next').click(this.navNext.bind(this));
        $('.btn-prev').click(this.navPrev.bind(this));
    }

    navNext() {
        $('body').addClass('slidestart');
        let slide = parseInt(this.slickController.slick('slickCurrentSlide')) + 1;

        if (slide === PlannerSections.groupSelection && plannerApplication.data.courseGroups.length <= 1) {
            slide += 1;
        }

        plannerApplication.movedToSection(slide);
        this.slickController.slick('slickGoTo', slide);
    }
    
    navPrev() {
        if (parseInt(this.slickController.slick('slickCurrentSlide')) === 1) {
            $('body').removeClass('slidestart');
            $('.title').html('');
        }
        let slide = parseInt(this.slickController.slick('slickCurrentSlide')) - 1;
        if (slide === PlannerSections.groupSelection && plannerApplication.data.courseGroups.length <= 1) {
            slide -= 1;
        }
        plannerApplication.movedToSection(slide);
        this.slickController.slick('slickGoTo', slide);
    }

    //remove header on schedule slider
    removeHeader(slick, currentSlide) {
        let CurrentSlideDom = $(slick.$slides.get(currentSlide));
        let hideheader = CurrentSlideDom.find('.hide-header');
        if (hideheader.length > 0) {
            $('body').addClass('noheader');
        } else {
            $('body').removeClass('noheader');
        }
    }

    //remove header on schedule slider
    actions(slick, currentSlide) {
        let CurrentSlideDom = $(slick.$slides.get(currentSlide));
        let dataId = $('.slick-current').attr("data-slick-index");
        let title = CurrentSlideDom.find('.heading');
        if (title.length > 0) {
            $('.heading-title').html(title[0].innerText);
        }

        /*let showtips = CurrentSlideDom.find('.showtips');
        if (showtips.length > 0) {
            setTimeout(function () {
                $('#modaltips').modal('show');
                $('body').addClass('tips-show');
            }, 1000);
        }*/
    }

    navContentsResized() {
        let currentSlide = $('.slick-current');
        let height = currentSlide.outerHeight(true);
        $(".slick-list").height(height);
        this.slickController.resize();
    }
}
